<script lang="ts">
import { defineComponent } from 'vue';
import type { CMSPageTypes } from '@fibl/oxs-common';
import CmsMarkdownDisplay from '@/components/cms/display.vue';
import { type EAV } from '@fibl/zdb-common';
import * as SearchRepo from '@/repository/search';
import Etracker from '../util/etracker.vue';

const CMS_FALLBACK_LANGUAGE = 'en_GB';

export default defineComponent({
	name: 'CmsPageDisplay',

	components: {
		CmsMarkdownDisplay,
		Etracker,
	},

	props: {
		usage: {
			type: String,
		},
		id: {
			type: String,
		},
		openLinksInNewWindow: {
			type: Boolean,
		},
	},

	data() {
		return {
			title: '',
			content: '',
			entity: {} as EAV.Entity<CMSPageTypes.CmsPage>,
		};
	},

	computed: {
		language() {
			return this.$globalStore.websiteStore.locale;
		},
	},

	created() {
		this.$watch(() => this.language, this.init, { immediate: true });
		this.$watch(() => this.id, this.init);
		this.$watch(() => this.usage, this.init);
		console.log('created cms page');
	},

	methods: {
		async init() {
			if (!this.entity.id || (this.id && this.id !== this.entity.id)) {
				let ent: EAV.Entity<CMSPageTypes.CmsPage>;
				if (this.usage) {
					[ent] = await SearchRepo.findAll(
						'cmspage',
						{
							field: '/data/usage',
							comparison: 'eq',
							value: this.usage,
						},
						true,
					);
				} else if (this.id) {
					ent = await SearchRepo.getEntityById(this.id);
				} else {
					return;
				}
				if (!ent) return;
				this.entity = ent;
			}
			let lang = this.$globalStore.websiteStore.locale;
			let page = this.entity.data.page.find((e) => e.lang === lang);
			if (!page) page = this.entity.data.page.find((e) => e.lang === CMS_FALLBACK_LANGUAGE);
			if (!page) return;
			this.title = page.title;
			this.content = page.content;
			if (this.title) {
				document.title = this.title;
			}
		},
	},
});
</script>

<template>
	<h2>{{ title }}</h2>
	<CmsMarkdownDisplay
		:markdown="content"
		:open-links-in-new-window="openLinksInNewWindow"
	/>
	<template v-if="entity.data?.usage === 'data-privacy'">
		<Etracker show-opt-out />
	</template>
</template>
